//The actual client-side config values are to be placed inside of index.html file.
//This is because it's the only file that remains not bundled after building front-end for Production
//and therefore can be edited after the app is built.
//Notes:
//1. Do not place any secret values there. These should come from ResWebApi (after succesful auth).
//   Ideally, client-side config should only consists of URL to ResWebApi.
//   This would not only be more secure but also would prevent unnecesary spread of config values and potential mismatch between front-end and api config values.

const sampleRescoConfig = {
    ResWebApiUrl: "ResWebApiUrl",
    RouterBaseName: "RouterBaseName",
  };
  type TRescoConfig = typeof sampleRescoConfig;
  
  interface IRescoWindow {
    RescoConfig: TRescoConfig;
  }
  const RescoConfig = ((window as unknown) as IRescoWindow).RescoConfig;
  
  //Responsibility: Provides environment/installation specific values.
  export default RescoConfig;
  